import axios from "axios";
import { FAQ_API } from "./config";

const authHeaders = (token) => ({ authorization: `Bearer ${token}` });

export const uploadForPreview = (token, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${FAQ_API}/faq/import`, formData, {
      headers: authHeaders(token),
    })
    .then((res) => res.data);
};

export const confirmImport = (token, rows) =>
  axios
    .post(
      `${FAQ_API}/faq/import/confirm`,
      { rows },
      { headers: authHeaders(token) },
    )
    .then((res) => res.data);

export const getTemplateUrl = () => `${FAQ_API}/faq/template`;
